import { useQuery } from '@tanstack/react-query';
import { getVersion } from 'api/authApi';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PCSOlogo from 'assets/img/logov1.svg';
import Icon from 'components/icon/Icon';
import { QUERY_KEYS } from 'constants/constants';

interface IBrandProps {
	asideStatus: boolean;
	setAsideStatus(...args: unknown[]): unknown;
	navigateLink: string;
}
const Brand = ({ asideStatus, setAsideStatus, navigateLink }: IBrandProps) => {
	const { VERSION } = QUERY_KEYS;
	const versionQuery = useQuery([VERSION], () => getVersion());
	return (
		<div className='brand mt-2'>
			<div className='brand-logo'>
				<h1 className='brand-title'>
					<Link to={navigateLink} aria-label='Logo'>
						<img src={PCSOlogo} alt='logo' height={50} width={150} />
					</Link>
				</h1>
				<small className='mt-10' style={{ color: '#ccc' }}>
					{/* Version {process.env.REACT_APP_VERSION} */}
					Version {versionQuery.data?.data}
				</small>
			</div>
			<button
				type='button'
				className='btn brand-aside-toggle'
				aria-label='Toggle Aside'
				onClick={() => setAsideStatus(!asideStatus)}>
				<Icon icon='FirstPage' className='brand-aside-toggle-close' />
				<Icon icon='LastPage' className='brand-aside-toggle-open' />
			</button>
		</div>
	);
};
Brand.propTypes = {
	asideStatus: PropTypes.bool.isRequired,
	setAsideStatus: PropTypes.func.isRequired,
};

export default Brand;
